import { subMonths, format } from 'date-fns';

export const getCalculatedDateFilter = (
    numMonths: number | null,
    fromDate: number
) => {
    if (!numMonths) return;
    else return format(subMonths(fromDate, numMonths), 'yyyy-MM-dd');
};
